export default "__VITE_ASSET__a1b52f06__"